import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaBars,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";
import { motion } from "framer-motion";
import Logo from "../Images/logo.png";
import { buyers, sellers, usefulLinks } from "../Data";

const Header = ({
  showBreadcrumb = false,
  pageName = "",
  breadcrumbItems = [],
}) => {

  // MAIN HEADER FADE
  const headerVariants = {
    hidden: {
      opacity: 0,
      y: -30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: 0.12,
      },
    },
  };

  // CHILD ANIMATION
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: -18,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // NAV LINK HOVER
  const navHover = {
    y: -2,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  };

  const [sidebarOpen, setSidebarOpen] =
  useState(false);

const [buyersOpen, setBuyersOpen] =
  useState(false);

const [sellersOpen, setSellersOpen] =
  useState(false);

  const [UsefulLinksOpen, setUsefulLinksOpen] =
  useState(false);

  return (
    <>
      <motion.header
        className="header"
        initial="hidden"
        animate="visible"
        variants={headerVariants}
      >

        {/* TOP HEADER */}
        <div className="top-header">
          <div className="container top-header-container">

            {/* LOGO */}
            <motion.div variants={itemVariants}>
              <Link to="/" className="logo-wrap">
                <motion.img
                  src={Logo}
                  alt="LDL Settlement Services Logo"
                  className="logo"
                  whileHover={{
                    scale: 1.04,
                  }}
                  transition={{
                    duration: 0.35,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                />
              </Link>
            </motion.div>

            {/* RIGHT */}
            <motion.div
              className="top-header-right"
              variants={itemVariants}
            >

              <motion.a
                href="mailto:admin@ldlsettlementservices.com.au"
                className="top-contact"
                whileHover={{
                  y: -2,
                  opacity: 0.8,
                }}
                transition={{
                  duration: 0.25,
                }}
              >
                <FaEnvelope />
                admin@ldlsettlementservices.com.au
              </motion.a>
                <div className="call-group">
              <motion.a
                href="tel:0861566225"
                className="top-contact"
                whileHover={{
                  y: -2,
                  opacity: 0.8,
                }}
                transition={{
                  duration: 0.25,
                }}
              >
                <FaPhoneAlt />
                (08) 6156 6225
              </motion.a><span>|</span><motion.a href="tel:0420360030" className="top-contact"
                whileHover={{
                  y: -2,
                  opacity: 0.8,
                }}
                transition={{
                  duration: 0.25,
                }}>
                  04 2036 0030
                </motion.a>
                </div>

              <motion.a
                className="primary-btn"
                href="\get-a-quote"
                whileHover={{
                  y: -3,
                  scale: 1.02,
                }}
                whileTap={{
                  scale: 0.97,
                }}
                transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                Get a Quote
              </motion.a>

            </motion.div>
            {/* MOBILE HAMBURGER */}

<button
  className="hamburger-btn"
  onClick={() =>
    setSidebarOpen(!sidebarOpen)
  }
>

  {sidebarOpen ? (
    <FaTimes />
  ) : (
    <FaBars />
  )}

</button>
          </div>
        </div>

        {/* NAVBAR */}
        <motion.div
          className="navbar"
          variants={itemVariants}
        >
          <div className="container nav-container">

            <nav className="nav-links">

              <motion.div whileHover={navHover}>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "nav-link active-nav" : "nav-link"
                  }
                >
                  Home
                </NavLink>
              </motion.div>

              <motion.div whileHover={navHover}>
                <NavLink
                  to="/about-us"
                  className={({ isActive }) =>
                    isActive ? "nav-link active-nav" : "nav-link"
                  }
                >
                  About us
                </NavLink>
              </motion.div>

              <motion.div whileHover={navHover}>
                <NavLink
                  to="/services"
                  className={({ isActive }) =>
                    isActive ? "nav-link active-nav" : "nav-link"
                  }
                >
                  Services
                </NavLink>
              </motion.div>

              <motion.div whileHover={navHover}>
               <div className="nav-dropdown">

  <div className="nav-dropdown-head">

    <span className="nav-link">
      For Buyers
    </span>

    <FaChevronDown />

  </div>

  <div className="dropdown-menu">

   
         {buyers.map((item, i) => (

    <NavLink
      key={i}
      to={`/buyers/${item.slug}`}
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      {item.title}
    </NavLink>

  ))}

  </div>

</div>
              </motion.div>

              <motion.div whileHover={navHover}>
               <div className="nav-dropdown">

  <div className="nav-dropdown-head">

    <span className="nav-link">
      For Sellers
    </span>

    <FaChevronDown />

  </div>

  <div className="dropdown-menu">

    {sellers.map((item, i) => (

    <NavLink
      key={i}
      to={`/sellers/${item.slug}`}
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      {item.title}
    </NavLink>

  ))}

  </div>

</div>
              </motion.div>

              {/*<motion.div whileHover={navHover}>
                <NavLink
                  to="/blog"
                  className={({ isActive }) =>
                    isActive ? "nav-link active-nav" : "nav-link"
                  }
                >
                  Blog
                </NavLink>
              </motion.div>*/}

               <motion.div whileHover={navHover}>
               <div className="nav-dropdown useful-links-dropdown">

  <div className="nav-dropdown-head">

    <span className="nav-link">
     Useful Links
    </span>

    <FaChevronDown />

  </div>

  <div className="dropdown-menu">

   
         {usefulLinks.map((item, i) => (

    <NavLink
      key={i}
      to={`${item.slug}`}
      target={
      item.slug === "/blog"
        ? "_self"
        : "_blank"
    }
    rel={
      item.slug === "/blog"
        ? undefined
        : "noopener noreferrer"
    }
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      {item.title}
    </NavLink>

  ))}

  </div>

</div>
              </motion.div>

              <motion.div whileHover={navHover}>
                <NavLink
                  to="/contact-us"
                  className={({ isActive }) =>
                    isActive ? "nav-link active-nav" : "nav-link"
                  }
                >
                  Contact us
                </NavLink>
              </motion.div>

            </nav>
          </div>
        </motion.div>

        {/* BREADCRUMB */}
       {/* BREADCRUMB */}

{showBreadcrumb && (

  <motion.div
    className="breadcrumb-bar"
    initial={{
      opacity: 0,
      y: 20,
    }}
    animate={{
      opacity: 1,
      y: 0,
    }}
    transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
      delay: 0.2,
    }}
  >

    <div className="container breadcrumb-container">

      <p>

        <Link to="/">
          Home
        </Link>

        {breadcrumbItems.length > 0 ? (

          breadcrumbItems.map((item, index) => (

            <React.Fragment key={index}>

              <span>{">"}</span>

              {item.link ? (

                <Link to={item.link}>
                  {item.label}
                </Link>

              ) : (

               <span
  className={`active-breadcrumb ${
    breadcrumbItems.length > 1
      ? "service-breadcrumb"
      : ""
  }`}
>
  {item.label}
</span>

              )}

            </React.Fragment>

          ))

        ) : (

          <>
            <span>{">"}</span>

            <span className="active-breadcrumb">
              {pageName}
            </span>
          </>

        )}

      </p>

    </div>

  </motion.div>

)}
  {/* MOBILE SIDEBAR */}

<div
  className={`mobile-sidebar ${
    sidebarOpen
      ? "show-sidebar"
      : ""
  }`}
>

  {/* TOP */}

  <div className="sidebar-top">

    <img
      src={Logo}
      alt="LDL Logo"
      className="sidebar-logo"
    />

  </div>

  {/* LINKS */}

  <div className="sidebar-links">

    <NavLink
      to="/"
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      Home
    </NavLink>

    <NavLink
      to="/about-us"
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      About us
    </NavLink>

    <NavLink
      to="/services"
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      Services
    </NavLink>

    {/* BUYERS */}

    <div className="mobile-dropdown">

      <button
        onClick={() =>
          setBuyersOpen(!buyersOpen)
        }
      >

        For Buyers

        <FaChevronDown
          className={
            buyersOpen
              ? "rotate-icon"
              : ""
          }
        />

      </button>

      <div
        className={`mobile-dropdown-menu ${
          buyersOpen
            ? "show-mobile-dropdown"
            : ""
        }`}
      >

         {buyers.map((item, i) => (

    <NavLink
      key={i}
      to={`/buyers/${item.slug}`}
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      {item.title}
    </NavLink>

  ))}

      </div>

    </div>

    {/* SELLERS */}

    <div className="mobile-dropdown">

      <button
        onClick={() =>
          setSellersOpen(!sellersOpen)
        }
      >

        For Sellers

        <FaChevronDown
          className={
            sellersOpen
              ? "rotate-icon"
              : ""
          }
        />

      </button>

      <div
        className={`mobile-dropdown-menu ${
          sellersOpen
            ? "show-mobile-dropdown"
            : ""
        }`}
      >

      {sellers.map((item, i) => (

    <NavLink
      key={i}
      to={`/sellers/${item.slug}`}
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      {item.title}
    </NavLink>

  ))}

      </div>

    </div>

   <div className="mobile-dropdown">

      <button
        onClick={() =>
          setUsefulLinksOpen(!UsefulLinksOpen)
        }
      >

       Useful Links

        <FaChevronDown
          className={
            UsefulLinksOpen
              ? "rotate-icon"
              : ""
          }
        />

      </button>

      <div
        className={`mobile-dropdown-menu ${
          UsefulLinksOpen
            ? "show-mobile-dropdown"
            : ""
        }`}
      >

      {usefulLinks.map((item, i) => (

    <NavLink
      key={i}
      to={`${item.slug}`}
       target={
      item.slug === "/blog"
        ? "_self"
        : "_blank"
    }
    rel={
      item.slug === "/blog"
        ? undefined
        : "noopener noreferrer"
    }
      onClick={() =>
        setSidebarOpen(false)
      }
    >
      {item.title}
    </NavLink>

  ))}

      </div>

    </div>

    <NavLink to="/contact-us">
      Contact us
    </NavLink>

     <NavLink to="/get-a-quote">
      Get a Quote
    </NavLink>

  </div>

  {/* FOOTER */}

  <div className="sidebar-footer">

    <a href="mailto:admin@ldlsettlementservices.com.au">
      <FaEnvelope />
      admin@ldlsettlementservices.com.au
    </a>

    <a href="tel:0861566225">
      <FaPhoneAlt />
     <div className="call-group call-group-special"> (08) 6156 6225<span>|</span><a href="tel:0420360030" >04 2036 0030</a></div>
    </a>

    <div className="sidebar-socials">

      <a href="https://www.facebook.com/profile.php?id=61590578334268"
      target="_blank"
    rel="noopener noreferrer">
        <FaFacebookF />
      </a>

      <a href="https://www.linkedin.com/company/ldl-settlement-services-perth"
       target="_blank"
    rel="noopener noreferrer">
        <FaLinkedinIn />
      </a>

    </div>

  </div>

</div>

{/* OVERLAY */}

<div
  className={`sidebar-overlay ${
    sidebarOpen
      ? "show-overlay"
      : ""
  }`}
  onClick={() =>
    setSidebarOpen(false)
  }
/>
      </motion.header>
    </>
  );
};

export default Header;